import { InvitationStatusType } from '@vi-iot/client';

export namespace CommercialMappers {
  export function getProperStatusOnInvitationRemoval(
    currentInvitationStatus: InvitationStatusType | undefined
  ): InvitationStatusType {
    switch (currentInvitationStatus) {
      case InvitationStatusType.Pending:
        return InvitationStatusType.Canceled;
      case InvitationStatusType.Accepted:
        return InvitationStatusType.Terminated;
      case InvitationStatusType.Rejected:
        return InvitationStatusType.Terminated;
      case InvitationStatusType.Expired:
        return InvitationStatusType.Terminated;
    }
  }
}
